import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentComponent } from '../../components/content/content.component';
import { BreadcrumbsComponent } from '../../common/breadcrumbs/breadcrumbs.component';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AlertComponent } from '../../common/alert/alert.component';
import { PaymentBaseAllBaseReadPaymentAllPaymentRead } from '../../openapi';
import { PaymentCommonService } from '../../services/payment.common.service';
import { PaymentStatusPipe } from '../../pipes/payment-status.pipe';
import { PaymentStatusCheckerComponent } from '../../common/payment-status-checker/payment-status-checker.component';
import { SessionService } from '../../services/ssession.service';

@Component({
  selector: 'app-payments-status-page',
  standalone: true,
  imports: [
    CommonModule,
    ContentComponent,
    BreadcrumbsComponent,
    RouterModule,
    AlertComponent,
    PaymentStatusPipe,
    PaymentStatusCheckerComponent
  ],
  providers: [
    PaymentCommonService
  ],
  templateUrl: './payments-status-page.component.html'
})
export class PaymentsStatusPageComponent {

  public paymentToken: string | undefined = this.route.snapshot.params['payment_token'];

  public appId: string | undefined = this.route.snapshot.params['appId'];

  public serviceType: string | undefined = this.route.snapshot.params['serviceType'];

  public authed: boolean = SessionService.Authed();

  constructor(
    private route: ActivatedRoute
  ) {
  }
}
